const t="·",e=({depositType:t,maturity:e,showDepositTypeInMaturity:p})=>e?p?`${e} ${t}`:`· ${e.replace(/\s/g," ")} ·`:"";export{t as MATURITY_SYMBOL,e as default};
//# sourceMappingURL=createMaturityInfo.js.map
